import { useSelector } from 'react-redux';

import { HelpTopic } from '../services/helpTopicsService';
import { RootState } from '../store/store';


/**
 * Look up a single help topic by its help_tag_name from Redux.
 * Returns the matching HelpTopic, or undefined if not found.
 */
export const useReduxHelpTopic = (helpTagName: string): HelpTopic | undefined => {
	const helpTopics = useSelector(
		(store: RootState) => store.referenceReducer.helpTopics?.content,
	) as HelpTopic[] | undefined;
	return helpTopics?.find(
		(topic) => topic.help_tag_name === helpTagName && topic.content_type !== null,
	);
};
